import { useNavigate, useParams } from "react-router-dom";
import { ROUTE_SLUGS, ROUTES } from "src/config/navigation/routes";
import { useRestoreDocumentMutation } from "src/hooks/mutations";
import { fillRouteWithSlugs } from "src/utils/navigation";
import DocViewerMoreOptions from "./DocViewerMoreOptions";

export const DeletedDocumentMoreOptions = ({
  dataTestId = "deleted-document-more-options-button",
  documentId,
}: {
  dataTestId?: string;
  documentId: string;
}) => {
  const navigate = useNavigate();
  const { orgId = "" } = useParams<{ orgId: string }>();
  const restoreMutation = useRestoreDocumentMutation();

  const restoreDocument = () => {
    restoreMutation.mutate(
      { docId: documentId, orgId },
      {
        onSuccess: () => {
          navigate(
            `${fillRouteWithSlugs(ROUTES.DOCUMENTS, {
              [ROUTE_SLUGS.ORG_ID]: orgId,
            })}?view=trash`,
            { replace: true }
          );
        },
      }
    );
  };

  return (
    <DocViewerMoreOptions
      dataTestId={dataTestId}
      hideTriggerTooltip={false}
      isDisabled={restoreMutation.isPending}
      menuId={`deleted-document-actions-${documentId}`}
      normalButtons={[{ title: "Restore", onClick: restoreDocument }]}
      triggerAriaLabel="More options"
      triggerTooltipTitle="More options"
    />
  );
};
